import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BrandWithAction from '../../common/BrandWithAction';
import styles from './MyBrands.module.scss';

function MyBrands(props) {
  const { suppliers, invitations } = useSelector((state) => state.adminBrands);

  const sellers = [...suppliers, ...invitations];

  if (sellers.length) {
    return (
      <ul className={styles.container}>
        {sellers.map((value) => (
          <li key={value.supplier.id}>
            <BrandWithAction item={value} openAcceptInvitationModal={props.openAcceptInvitationModal} />
          </li>
        ))}
      </ul>
    );
  } else {
    return <span className={styles.noData}>No brands are connected to your user</span>;
  }
}

MyBrands.propTypes = {
  openAcceptInvitationModal: PropTypes.func.isRequired,
};

export default MyBrands;
